/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolTornadoIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-tornado"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M2.75 6.65L3.33 7.67L20.68 7.67L21.25 6.65Q22.02 5.3 21.27 3.99Q20.52 2.67 18.98 2.67L5.03 2.67Q3.48 2.67 2.73 3.99Q1.98 5.3 2.75 6.65ZM4.88 10.32L6.22 12.68L17.77 12.68L19.13 10.32ZM7.75 15.32L9.7 18.68Q10.47 20.02 12 20.02Q13.53 20.02 14.3 18.68L16.25 15.32Z" fill={color} />
    </svg>
  );
}
